import ReactModal from "react-modal";

type Props = ReactModal.Props;

// Add ariaHideApp for all ReactModal component for accessibility.
export const KibelaModal: React.FC<Props> = (props) => {
  return <ReactModal {...props} ariaHideApp={false} />;
};
